var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineSecurityUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.98 21.81-4.3-3.21c-1.14-.85-2.03-2.62-2.03-4.04V7.13c0-1.54 1.13-3.18 2.58-3.72l4.99-1.87c.99-.37 2.55-.37 3.54 0l5 1.87c1.45.54 2.58 2.18 2.58 3.72v7.43c0 1.42-.89 3.19-2.03 4.04l-4.3 3.21c-.84.63-1.92.95-3.01.95-1.09 0-2.17-.32-3.02-.95zm-3.22-17c-.86.32-1.61 1.4-1.61 2.32v7.43c0 .95.67 2.28 1.42 2.84l4.3 3.21c1.15.86 3.1.86 4.25 0l4.3-3.21c.76-.57 1.42-1.9 1.42-2.84V7.13c0-.91-.75-1.99-1.61-2.32l-4.99-1.87c-.66-.25-1.82-.25-2.49 0L5.76 4.81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.93 11.67c-1.45-.04-2.51-1.15-2.51-2.5 0-1.38 1.13-2.51 2.51-2.51s2.51 1.13 2.51 2.51a2.514 2.514 0 0 1-2.42 2.51c-.01-.01-.01-.01-.02-.01h-.07zm-1.01-2.5c0 .55.43.99.97 1.01H12a1 1 0 0 0 .94-1.01 1 1 0 0 0-1.01-1.01c-.56 0-1.01.45-1.01 1.01zM9.6 16.67c-.67-.44-1.05-1.09-1.05-1.78s.38-1.34 1.05-1.79c1.35-.9 3.46-.89 4.8 0 .67.44 1.05 1.09 1.05 1.78s-.38 1.34-1.05 1.79c-.67.45-1.54.68-2.4.68-.86 0-1.73-.23-2.4-.68zm.45-1.79c0 .18.14.38.38.54.84.56 2.3.56 3.14 0 .25-.16.39-.36.39-.54 0-.18-.14-.38-.38-.54-.84-.55-2.31-.55-3.15 0-.25.16-.39.36-.38.54z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineSecurityUser);
export default __webpack_public_path__ + "static/media/vuesax-outline-security-user.288b2b7db323a465fb196b8f18545a06.svg";
export { ForwardRef as ReactComponent };